import { Inject, Injectable } from '@angular/core';

import { catchError, map, Observable, of } from 'rxjs';

import { UserService } from '@authentication/services/user.service';

import { DIAGNOSTIC_PROFILES_TOKEN } from '../constants/diagnostic-profiles.const';
import { DiagnosticProfile } from '../models/diagnostic-profile';

@Injectable({ providedIn: 'root' })
export class DiagnosticProfileService {
  constructor(
    private readonly userService: UserService,
    @Inject(DIAGNOSTIC_PROFILES_TOKEN)
    private readonly profiles: readonly DiagnosticProfile[]
  ) {}

  getAvailableProfiles(): Observable<DiagnosticProfile[]> {
    return this.userService.getRoles().pipe(
      map((roles) =>
        this.profiles.filter(
          (profile) =>
            !profile.requiredRole ||
            (roles ?? []).includes(profile.requiredRole)
        )
      ),
      catchError((err) => {
        console.error('[DiagnosticProfileService] role lookup failed', err);
        return of([]);
      })
    );
  }
}
